import { useQuery } from 'react-query';
import { getPublicDutyHourTypes } from 'RestAPIs/employees/leave-requests';

const useGetPublicDutyHourTypes = () => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['publicDutyHourTypes', 'list'],
    async () => {
      const { data } = await getPublicDutyHourTypes();
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetPublicDutyHourTypes;
